import { render, staticRenderFns } from "./OrderSubmissionRetailer.vue?vue&type=template&id=6939e6a0&scoped=true&"
import script from "./OrderSubmissionRetailer.vue?vue&type=script&lang=ts&"
export * from "./OrderSubmissionRetailer.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSubmissionRetailer.vue?vue&type=style&index=0&id=6939e6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6939e6a0",
  null
  
)

export default component.exports